

















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { registUser } from '@/api/regist';
import { DoctorRegistData, UserType, ErrorType } from '../../../common/dist/common';

interface VueForm extends HTMLElement {
  validate(): boolean;
  reset(): void;
  resetValidation(): void;
}

@Component
export default class Regist extends Vue {
  private loading = false;
  private error = '';
  private valid0 = false;
  private valid1 = false;
  private doctorData: Partial<DoctorRegistData> = {};
  private weeks = 0;
  private days = 0;
  private success = false;
  public showSuccess = false;

  public async onConfirm() {
    this.loading = true;

    const ret = await this.confirmDoctor();
    if (!ret.success) {
      this.showError(ret.message);
    } else {
      this.showSuccess = true;
      this.success = true;
    }

    this.loading = false;
  }

  private showError(key: ErrorType) {
    switch (key) {
      case ErrorType.Exists:
        this.error = 'Already registered.';
        break;
      default:
        this.error = 'Unknown Error.';
    }
  }

  private confirmDoctor() {
    const data: Partial<DoctorRegistData> = {
      ...this.doctorData,
      type: UserType.Doctor,
    };
    return registUser(data);
  }

  public get canSubmit() {
    return this.valid1;
  }

  @Watch('patientData.password')
  public onChangePassword() {
    const form = this.$refs.form0 as VueForm;
    form.validate();
  }

  public passwordCompare() {
    return (val: string) => {
      if (val === this.doctorData.password) {
        return true;
      }
      return 'Password mismatch';
    };
  }

  public onActivate() {
    this.$router.push({
      name: 'activate',
      params: {
        email: this.doctorData.email || '',
      },
    });
  }
}
